import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import * as ActivityDetailLevel from 'const/ActivityDetailLevel'
import Scrollbars from 'components/Scrollbars'
import {
  BoardModalView,
  ViewBody
} from 'components/Sidebar'
import {
  ModalMenu
} from 'components/Modal'
import {
  MenuItem
} from 'components/Menu'
import { runSaga } from 'store/sagaMiddleware'
import boardActivitiesChannelData from '../../sagas/boardActivitiesChannelData'
import Activities from 'routes/Board/Activities'
import classes from './Activities.module.scss'

export class BoardActivities extends React.Component {
  static propTypes = {
    id: PropTypes.number.isRequired,

    activitiesDetailLevel: PropTypes.number.isRequired,

    requestChangeUserSettings: PropTypes.func.isRequired,
    requestMarkBoardAsRead: PropTypes.func.isRequired,
  }

  static DETAIL_LEVELS = [
    {
      id: ActivityDetailLevel.ALL,
      formattedMessageId: 'ACTIVITY_DETAIL_LEVEL_ALL'
    },
    {
      id: ActivityDetailLevel.IMPORTANT,
      formattedMessageId: 'ACTIVITY_DETAIL_LEVEL_IMPORTANT'
    },
    {
      id: ActivityDetailLevel.COMMENTS,
      formattedMessageId: 'ACTIVITY_DETAIL_LEVEL_COMMENTS'
    }
  ]

  componentDidMount = () => {
    const { id, requestMarkBoardAsRead } = this.props

    this.channelDataSaga = runSaga(boardActivitiesChannelData, id)

    requestMarkBoardAsRead({
      id,
    })
  }

  componentWillUnmount () {
    if (this.channelDataSaga) this.channelDataSaga.cancel()
  }

  render () {
    const {
      activitiesDetailLevel,

      requestChangeUserSettings
    } = this.props

    return (
      <BoardModalView
        className={classes.view}
        title={<FormattedMessage id='ACTIVITY_STREAM_HEADER' />}
      >
        <ViewBody
          className={classes.detailLevel}
        >
          <FormattedMessage id='ACTIVITY_DETAIL_LEVEL' />:
          {' '}
          <ModalMenu
            attachment='top center'
            targetAttachment='bottom center'
          >
            <a>
              <FormattedMessage
                id={
                  BoardActivities.DETAIL_LEVELS
                    .find(detailLevel => detailLevel.id === activitiesDetailLevel)
                    .formattedMessageId
                }
              />
            </a>
            {BoardActivities.DETAIL_LEVELS.map(detailLevel =>
              <MenuItem
                key={detailLevel.id}
                active={detailLevel.id === activitiesDetailLevel}
                onClick={() => {
                  requestChangeUserSettings({
                    activitiesDetailLevel: detailLevel.id
                  })
                }}
              >
                <FormattedMessage
                  id={detailLevel.formattedMessageId}
                />
              </MenuItem>
            )}
          </ModalMenu>
        </ViewBody>
        <Scrollbars
          component={ViewBody}
          className={classes.activities}
        >
          <Activities />
        </Scrollbars>
      </BoardModalView>
    )
  }
}

export default BoardActivities
